import {BaseComponent} from '../../../shared/components/base.component';
import {Component, OnInit} from '@angular/core';
import {Message} from '../../../shared/model/message';
import {NotificationsService} from '../../../shared/service/notifications.service';
import {Router} from '@angular/router';
import {tap} from 'rxjs/internal/operators';

@Component({
  selector: 'app-dashboard-messages-card',
  templateUrl: './dashboard-messages-card.component.html',
  styleUrls: ['./dashboard-messages-card.component.scss'],
})
export class DashboardMessagesCardComponent extends BaseComponent implements OnInit {

  public list: Message[];
  public isLoading: boolean;
  public areUnreadMessagesSelected: boolean;


  constructor(private notificationsService: NotificationsService, private router: Router) {
    super();
  }

  ngOnInit() {
    this.init();
    this.showUnreadMessages();
  }

  public init() {
    this.list = [];
  }

  public showUnreadMessages() {
    this.areUnreadMessagesSelected = true;
    this.getUnreadNotificationsMessages();
  }

  public showLatestMessages() {
    this.areUnreadMessagesSelected = false;
    this.getLatestNotificationsMessages();
  }

  private getUnreadNotificationsMessages() {
    this.isLoading = true;
    this.notificationsService.getUnreadNotificationsMessages()
      .pipe(
        tap(() => this.isLoading = false)
      )
      .subscribe(r => this.list = r);
  }

  private getLatestNotificationsMessages() {
    this.isLoading = true;
    this.notificationsService.getLatestNotificationsMessages()
      .pipe(
        tap(() => this.isLoading = false)
      )
      .subscribe(r => this.list = r);
  }

  public isListEmpty(): boolean {
    return !this.list.length;
  }

  public goToNotificationDetailsPage(message?: Message) {
    if (message) {
      this.router.navigate(['notifications', message.issueNotificationId], {queryParams: {id: message.issueNotificationId}});
    } else {
      this.router.navigate(['notifications']);
    }
  }
}

